/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type { GetAllFeaturesState200, GetFeatureStatePathParameters } from "../schemas";

import { customInstance } from "../../config/mutator";

export const getFeature = () => {
  /**
   * Returns a map of all feature flag names to their enabled state.
   * @summary Get all feature flag states
   */
  const getAllFeaturesState = () => {
    return customInstance<GetAllFeaturesState200>({ url: `/api/features`, method: "GET" });
  };
  /**
   * Returns whether the given feature flag is enabled.
   * @summary Get a feature flag state
   */
  const getFeatureState = ({ featureName }: GetFeatureStatePathParameters) => {
    return customInstance<boolean>({ url: `/api/features/${featureName}`, method: "GET" });
  };
  return { getAllFeaturesState, getFeatureState };
};
export type GetAllFeaturesStateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getFeature>["getAllFeaturesState"]>>
>;
export type GetFeatureStateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getFeature>["getFeatureState"]>>
>;
